import { styled } from 'stitches.config'

export const Header = styled('h2', {
  fontSize: '$h3',
  lineHeight: '$h3',

  '@bp2': {
    fontSize: '$h2',
    lineHeight: '$h2',
  },
})

export const TestimonialContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  color: '$accent-white',
  textAlign: 'center',
  gap: '$2',
  alignItems: 'center',
  width: '100%',
  margin: 'auto',
  maxWidth: '382px',

  '& > .author': {
    fontFamily: '$label',
  },

  '@bp2': {
    maxWidth: '1100px',
  },
})

export const MeatBanner = styled('div', {
  position: 'relative',
  width: '100%',
  aspectRatio: '2.62/1',
  display: 'block',
  lineHeight: 0,

  '& img': {
    objectPosition: 'top'
  },
  '@bp2': {
    display: 'none',
  },
})
